import { useCallback } from "react";

export function useShare() {
  return useCallback(
    async ({
      title,
      text,
      url,
    }: {
      title: string;
      text: string;
      url: string;
    }) => {
      if (navigator.share) {
        try {
          await navigator.share({
            title,
            text,
            url,
          });
        } catch (error) {
          console.log(error);
        }
      }
    },
    [],
  );
}
